(function(){
var C=window.FAVCFG||{};
var P=C.P,PR=C.PR,SORULAR=C.SORULAR||[],OZELLIKLER=C.OZELLIKLER||[];
/* ===== i18n köprüsü (bkz. sections/fav-konfigurator.liquid) ===== */
const I18N = window.FAV_KONFIG_I18N || {};
const T = (k, fallback) => (I18N[k] != null ? I18N[k] : fallback);
/* ===== Düz diziden DS / DF üret (eski yapıyla birebir) ===== */
var DS={};
SORULAR.slice().sort(function(a,b){return a.sira-b.sira}).forEach(function(q){
if(!DS[q.cozum])DS[q.cozum]=[];
var o={k:q.anahtar,t:q.tip,l:q.etiket};
if(q.tip==='range'){o.min=+q.min;o.max=+q.max;o.step=+q.adim;o.d=+q.varsayilan;o.u=q.birim;}
else{
o.opt=(q.secenekler||'').split('|').map(function(s){var i=s.indexOf(':');var v=(i>=0?s.slice(0,i):s).trim();var l=(i>=0?s.slice(i+1):s).trim();return {v:v,l:l};}).filter(function(x){return x.v});
if(q.tip==='multi'){o.d=q.varsayilan?q.varsayilan.split(',').map(function(s){return s.trim()}).filter(Boolean):[];}
else{o.d=q.varsayilan||'';}
}
DS[q.cozum].push(o);
});
var DF={};
OZELLIKLER.slice().sort(function(a,b){return a.sira-b.sira}).forEach(function(f){
if(!DF[f.cozum])DF[f.cozum]=[];
DF[f.cozum].push({v:f.anahtar,i:f.ikon,t:f.baslik,d:f.aciklama});
});
var SL={guvenlik:T('sl_guvenlik','Güvenlik'),yangin:T('sl_yangin','Yangın Algılama'),network:T('sl_network','Network'),'ses-goruntu':T('sl_ses_goruntu','Ses & Görüntü'),knx:T('sl_knx','Akıllı Bina (KNX)'),enerji:T('sl_enerji','Güç & Enerji'),dron:T('sl_dron','Dron'),signage:T('sl_signage','Video Wall')};
var LL={konut:T('ll_konut','Konut'),ofis:T('ll_ofis','Ofis'),perakende:T('ll_perakende','Perakende'),konaklama:T('ll_konaklama','Konaklama'),endustriyel:T('ll_endustriyel','Endüstriyel'),kamu:T('ll_kamu','Kamu / Eğitim')};
function gen(I){
var R=[],d=I.sc,F=I.ft;
if(I.sols.indexOf('guvenlik')>=0){
var sys=d.guvenlik_sys||['cctv'];
if(sys.indexOf('cctv')>=0){
var p=P.guvenlik,a=d.guvenlik_area||200;
var tc=Math.max(p.min_cams,Math.ceil(a/p.area_per_camera));
var oR=p.outdoor_ratio[I.loc]||.3,oN=Math.max(1,Math.round(tc*oR)),iN=Math.max(1,tc-oN);
var tier='st';
if(F.indexOf('ai')>=0) tier='ai';
else if(F.indexOf('colorvu')>=0) tier='cv';
R.push({k:'gv_in_'+tier,q:iN,r:T('role_gv_in','İç Mekan Kamera')});
R.push({k:'gv_ou_'+tier,q:oN,r:T('role_gv_ou','Dış Mekan Kamera')});
if(F.indexOf('ptz')>=0) R.push({k:'gv_ptz',q:1,r:T('role_gv_ptz','PTZ Speed Dome')});
R.push({k:tc<=8?'gv_nvr_8':'gv_nvr_16',q:1,r:T('role_gv_nvr','NVR Kayıt Cihazı')});
R.push({k:'gv_ups',q:1,r:T('role_gv_ups','Yedek Güç (UPS)')});
}
if(sys.indexOf('gecis')>=0) R.push({k:'gv_lock',q:Math.max(1,d.guvenlik_floors||1),r:T('role_gv_lock','Akıllı Kilit')});
if(sys.indexOf('alarm')>=0) R.push({k:'gv_alarm',q:1,r:T('role_gv_alarm','Alarm Sistemi')});
}
if(I.sols.indexOf('network')>=0){
var p2=P.network,u=d.network_users||25,cn=d.network_conn||['wireless'];
if(cn.indexOf('wireless')>=0){
var apN=Math.max(p2.min_aps,Math.ceil(u/p2.users_per_ap));
var apK=(I.loc==='endustriyel'||I.loc==='kamu')?'nt_ap_ou':'nt_ap_in';
R.push({k:apK,q:apN,r:T('role_nt_ap','Wi-Fi 6 Access Point')});
}
var swK=(u+p2.switch_buffer)<=10?'nt_sw_s':'nt_sw_l';
R.push({k:swK,q:1,r:T('role_nt_sw','PoE Switch')});
}
if(I.sols.indexOf('yangin')>=0){
var p3=P.yangin,fa=d.yangin_area||500,fl=d.yangin_floors||2;
var dN=Math.max(p3.min_det,Math.ceil(fa/p3.area_per_detector));
var bN=fl*p3.bildirim_per_floor;
var pK=dN<=30?'yn_p_s':dN<=100?'yn_p_m':'yn_p_l';
R.push({k:pK,q:1,r:T('role_yn_panel','Adresli Yangın Paneli')});
R.push({k:'yn_det',q:dN,r:T('role_yn_det','Duman Dedektörü')});
R.push({k:'yn_bil',q:bN,r:T('role_yn_bil','Bildirim Cihazı')});
}
if(I.sols.indexOf('ses-goruntu')>=0){
var t=d['ses-goruntu_type']||'mtg';
if(t==='conf') R.push({k:'sg_conf',q:1,r:T('role_sg_conf','Konferans Video Bar')});
else if(t==='pa') R.push({k:'sg_amp',q:1,r:T('role_sg_amp','Amplifikatör + Hoparlör')});
else R.push({k:'sg_av',q:1,r:T('role_sg_av','AV Receiver')});
}
['knx','enerji','dron','signage'].forEach(function(s){
if(I.sols.indexOf(s)>=0) R.push({k:'__ph_'+s,q:1,r:SL[s]+T('role_cozum_suffix',' Çözümü'),ph:1});
});
return R.map(function(it){
if(it.ph) return {k:it.k,n:it.r+T('ph_suffix',' — özel proje'),p:0,q:it.q,r:it.r,ph:1};
var pr=PR[it.k]||{};
return Object.assign({},pr,{k:it.k,q:it.q,r:it.r,st:(pr.p||0)*it.q});
});
}
var S={s:1,T:5,d:{loc:null,sols:[],sc:{},ft:[],name:'',tel:'',co:'',nt:''},gn:[],showProj:true};
var R=document.querySelector('.fav-page-cfg');
function A(q){return R.querySelectorAll(q)}
function Q(q){return R.querySelector(q)}
function tst(m,e){var t=Q('#ts');t.textContent=m;t.className='ts show'+(e?' err':'');clearTimeout(t._h);t._h=setTimeout(function(){t.className='ts'+(e?' err':'')},2400)}
function fmt(n){return n.toLocaleString(T('locale','tr-TR'),{minimumFractionDigits:2,maximumFractionDigits:2})}
function go(n){
A('.st').forEach(function(e){e.classList.toggle('active',+e.dataset.step===n)});
A('.tb').forEach(function(e){var t=+e.dataset.tab;e.classList.toggle('active',t===n);e.classList.toggle('done',t<n)});
Q('#sc2').textContent=n;
Q('#bb').disabled=(n===1);
Q('#bn').textContent=(n===S.T)?T('finish','Bitir'):T('next','İleri →');
if(n===3) rs();
if(n===4) rf();
if(n===5) rsm();
vl();
}
function vl(){
var s=S.s,d=S.d,ok=false;
if(s===1) ok=!!d.loc;
if(s===2) ok=d.sols.length>0;
if(s===3||s===4||s===5) ok=true;
Q('#bn').disabled=!ok;
}
function rs(){
var c=Q('#ds');c.innerHTML='';
if(S.d.sols.length===0){c.innerHTML='<div class="em">'+T('empty_step2','Önce Adım 2\'de çözüm alanı seçin.')+'</div>';return}
S.d.sols.forEach(function(sol){
var cfg=DS[sol]||[];if(!cfg.length)return;
var g=document.createElement('div');g.className='sg';
var html='<div class="gh"><span class="d"></span>'+SL[sol]+'</div>';
cfg.forEach(function(f){
var sk=sol+'_'+f.k;
if(S.d.sc[sk]===undefined) S.d.sc[sk]=f.d;
var cv=S.d.sc[sk];
if(f.t==='range'){
html+='<div class="rw"><div class="rl"><h4>'+f.l+'</h4><div class="rv" data-rv="'+sk+'">'+cv+' '+f.u+'</div></div>';
html+='<input type="range" min="'+f.min+'" max="'+f.max+'" step="'+f.step+'" value="'+cv+'" data-r="'+sk+'" data-u="'+f.u+'">';
html+='<div class="rm"><span>'+f.min+' '+f.u+'</span><span>'+f.max+' '+f.u+'</span></div></div>';
}else if(f.t==='single'){
html+='<div class="rw"><div class="rl"><h4>'+f.l+'</h4></div><div class="pillrow" style="padding:0" data-pill-s="'+sk+'">';
f.opt.forEach(function(o){html+='<button type="button" class="pill'+(cv===o.v?' sel':'')+'" data-v="'+o.v+'">'+o.l+'</button>'});
html+='</div></div>';
}else if(f.t==='multi'){
html+='<div class="rw"><div class="rl"><h4>'+f.l+'</h4></div><div class="pillrow" style="padding:0" data-pill-m="'+sk+'">';
f.opt.forEach(function(o){html+='<button type="button" class="pill'+((cv||[]).indexOf(o.v)>=0?' sel':'')+'" data-v="'+o.v+'">'+o.l+'</button>'});
html+='</div></div>';
}
});
g.innerHTML=html;c.appendChild(g);
});
c.querySelectorAll('input[type=range]').forEach(function(r){r.addEventListener('input',function(){var k=r.dataset.r;S.d.sc[k]=+r.value;var rv=c.querySelector('[data-rv="'+k+'"]');if(rv) rv.textContent=r.value+' '+r.dataset.u})});
c.querySelectorAll('[data-pill-s]').forEach(function(g){var k=g.dataset.pillS;g.querySelectorAll('.pill').forEach(function(p){p.addEventListener('click',function(){g.querySelectorAll('.pill').forEach(function(x){x.classList.remove('sel')});p.classList.add('sel');S.d.sc[k]=p.dataset.v})})});
c.querySelectorAll('[data-pill-m]').forEach(function(g){var k=g.dataset.pillM;g.querySelectorAll('.pill').forEach(function(p){p.addEventListener('click',function(){var arr=S.d.sc[k]||[],i=arr.indexOf(p.dataset.v);if(i>=0) arr.splice(i,1); else arr.push(p.dataset.v);S.d.sc[k]=arr;p.classList.toggle('sel')})})});
}
function rf(){
var c=Q('#df');c.innerHTML='';
if(S.d.sols.length===0){c.innerHTML='<div class="em">'+T('empty_step2','Önce Adım 2\'de çözüm alanı seçin.')+'</div>';return}
S.d.sols.forEach(function(sol){
var fs=DF[sol]||[];if(!fs.length)return;
var g=document.createElement('div');g.className='sg';
g.innerHTML='<div class="gh"><span class="d"></span>'+SL[sol]+'</div>';
var gr=document.createElement('div');gr.className='cg c4';gr.style.padding='6px 6px 14px';
fs.forEach(function(f){
var vu=sol+'__'+f.v,sel=S.d.ft.indexOf(vu)>=0;
var b=document.createElement('button');b.type='button';
b.className='sc'+(sel?' sel':'');b.dataset.fv=vu;
b.innerHTML='<div class="ic">'+f.i+'</div><h3>'+f.t+'</h3><p>'+f.d+'</p>';
b.addEventListener('click',function(){var i=S.d.ft.indexOf(vu);if(i>=0) S.d.ft.splice(i,1); else S.d.ft.push(vu);b.classList.toggle('sel')});
gr.appendChild(b);
});
g.appendChild(gr);c.appendChild(g);
});
}
function rsm(){
var d=S.d,sl=Q('#sl');sl.innerHTML='';
function ro(k,v){if(!v||(Array.isArray(v)&&!v.length))return;var e=document.createElement('div');e.className='ii';e.innerHTML='<span class="k">'+k+'</span><span class="v">'+v+'</span>';sl.appendChild(e)}
ro(T('sum_lokasyon','Lokasyon'),LL[d.loc]||'-');
ro(T('sum_cozumler','Çözümler'),d.sols.map(function(s){return SL[s]}).join(', '));
d.sols.forEach(function(s){
(DS[s]||[]).forEach(function(f){
var v=d.sc[s+'_'+f.k];
if(v===undefined||(Array.isArray(v)&&!v.length))return;
var dv;
if(f.t==='range') dv=v+' '+f.u;
else if(f.t==='single') dv=((f.opt.find(function(o){return o.v===v})||{}).l)||v;
else if(f.t==='multi') dv=v.map(function(x){return ((f.opt.find(function(o){return o.v===x})||{}).l)||x}).join(', ');
ro(SL[s]+' — '+f.l,dv);
});
});
var fd={};
d.ft.forEach(function(fv){var p=fv.split('__'),s=p[0],v=p[1];var m=(DF[s]||[]).find(function(x){return x.v===v});if(m){if(!fd[s])fd[s]=[];fd[s].push(m.t)}});
Object.keys(fd).forEach(function(s){ro(SL[s]+T('sum_ozellik_suffix',' — Özellik'),fd[s].join(', '))});
var I={loc:d.loc,sols:d.sols,sc:d.sc,ft:d.ft.map(function(f){return f.split('__')[1]})};
S.gn=gen(I);
renderPlist();
}
function renderPlist(){
var host=Q('#plist');host.innerHTML='';
var items=S.gn.filter(function(i){return S.showProj || (!i.ph && i.p>0)});
var by=S.gn.filter(function(i){return !i.ph&&i.p>0});
var pj=S.gn.filter(function(i){return i.ph||i.p===0});
var totalShown=items.length;
Q('#tcnt').textContent=totalShown+T('unit_urun',' ürün')+(S.showProj && pj.length?' · '+by.length+T('cnt_sepetlik',' sepete eklenebilir + ')+pj.length+T('cnt_proje',' proje'):'');
if(!items.length){host.innerHTML='<div class="em">'+T('empty_products','Önerilecek ürün bulunamadı. Çözüm alanı seçin.')+'</div>';}
else items.forEach(function(it){
var isProj=it.ph||it.p===0;
var d=document.createElement('div');d.className='pi'+(isProj?' proj':'');
var ih=it.img?'<div class="img"><img src="'+it.img+'" alt="'+String(it.n||'').replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;')+'" loading="lazy"></div>':'<div class="img phld">⊞</div>';
var pt,ac;
if(!isProj){
pt='<div class="pt2">'+fmt(it.st)+T('currency_suffix',' TL')+'</div>';
ac='<button class="ba" data-add="'+it.v+'" data-qty="'+it.q+'">'+T('btn_add','+ Sepete Ekle')+'</button><a class="bv" href="/products/'+it.h+'" target="_blank">'+T('btn_goto_product','Ürüne Git ↗')+'</a>';
}else{
pt='<div class="pt2 pj">'+T('price_on_request','Fiyat İçin Teklif')+'</div>';
ac=it.h?'<a class="bv" href="/products/'+it.h+'" target="_blank">'+T('btn_goto_product','Ürüne Git ↗')+'</a>':'<a class="bv" href="'+T('quote_page_url','/pages/teklif')+'?product='+encodeURIComponent(it.n||'')+'" target="_blank" rel="noopener">'+T('btn_request_quote','Teklif İste ↗')+'</a>';
}
var roleHtml='<div class="rl">'+it.r+(isProj?'<span class="bdg">'+T('badge_proje','PROJE')+'</span>':'')+'</div>';
var ul=!isProj?'<div class="ql"><b>'+it.q+T('unit_adet',' adet')+'</b> × '+fmt(it.p)+T('currency_suffix',' TL')+'</div>':'<div class="ql"><b>'+it.q+T('unit_adet',' adet')+'</b>'+T('suffix_onerilir',' önerilir')+'</div>';
d.innerHTML=ih+'<div class="mt">'+roleHtml+'<div class="nm">'+it.n+'</div>'+ul+'</div><div class="ac">'+pt+ac+'</div>';
host.appendChild(d);
});
var tq=0,tp=0;by.forEach(function(i){tq+=i.q;tp+=i.st});
Q('#bqt').textContent=tq+T('unit_adet',' adet');
Q('#bpt').textContent=fmt(tp)+T('currency_suffix',' TL');
var b=Q('#bca');b.disabled=by.length===0;
b.textContent=by.length?T('btn_addall_prefix','Sepete Ekle · ')+by.length+T('btn_addall_suffix',' ürün'):T('btn_addall_none','🛒 Sepete Eklenebilir Ürün Yok');
b.style.opacity=by.length?'1':'.5';
}
function add(v,q){return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:Number(v),quantity:Number(q)})}).then(function(r){if(!r.ok)throw new Error('cart_'+r.status);return r.json()})}
function addAll(){
var by=S.gn.filter(function(i){return !i.ph&&i.p>0&&i.v});
if(!by.length){tst(T('toast_no_items','Sepete eklenebilir ürün yok.'),1);return}
var b=Q('#bca');b.disabled=true;b.textContent=T('btn_adding','Ekleniyor...');
var its=by.map(function(i){return {id:Number(i.v),quantity:Number(i.q)}});
fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:its})}).then(function(r){if(!r.ok)throw new Error('cart_'+r.status);return r.json()}).then(function(){
tst(by.length+T('toast_added_suffix',' ürün sepete eklendi.'));b.textContent=T('btn_added','✓ Sepete Eklendi');
setTimeout(function(){location.href='/cart'},900);
}).catch(function(e){b.disabled=false;b.textContent=T('btn_addall_prefix','Sepete Ekle · ')+by.length+T('btn_addall_suffix',' ürün');tst(T('toast_add_failed','Sepete eklenemedi: ')+e.message,1)});
}
/* v26: Konfigürasyon özeti (eski WhatsApp metni) — ortak teklif formuna yazılır */
function summary(){
var d=S.d;
var L=[T('wa_title','*FAV Konfigüratör — Teklif Talebi*'),''];
L.push(T('wa_lokasyon','🏠 Lokasyon: ')+(LL[d.loc]||'-'));
L.push(T('wa_cozum','🔧 Çözüm: ')+d.sols.map(function(s){return SL[s]}).join(', '));
d.sols.forEach(function(s){(DS[s]||[]).forEach(function(f){
var v=d.sc[s+'_'+f.k];
if(v===undefined||(Array.isArray(v)&&!v.length))return;
var dv;
if(f.t==='range') dv=v+' '+f.u;
else if(f.t==='single') dv=((f.opt.find(function(o){return o.v===v})||{}).l)||v;
else if(f.t==='multi') dv=v.map(function(x){return ((f.opt.find(function(o){return o.v===x})||{}).l)||x}).join(', ');
L.push(' • '+SL[s]+' '+f.l+': '+dv);
})});
if(d.ft.length){
var fd={};d.ft.forEach(function(fv){var p=fv.split('__'),s=p[0],v=p[1];var m=(DF[s]||[]).find(function(x){return x.v===v});if(m){if(!fd[s])fd[s]=[];fd[s].push(m.t)}});
Object.keys(fd).forEach(function(s){L.push(' ✨ '+SL[s]+': '+fd[s].join(', '))});
}
L.push('');
var by=S.gn.filter(function(i){return !i.ph&&i.p>0}),pj=S.gn.filter(function(i){return i.ph||i.p===0});
if(by.length){
L.push(T('wa_sepetlik','🛒 *Sepete Eklenebilir:*'));
by.forEach(function(i){L.push(' '+i.q+'× '+i.n+' = '+fmt(i.st)+T('currency_suffix',' TL'))});
var t=by.reduce(function(a,b){return a+b.st},0);
L.push(' ───────');L.push(T('wa_total_prefix',' *Sepetlik Tutar: ')+fmt(t)+T('currency_suffix',' TL')+'*');L.push('');
}
if(pj.length){L.push(T('wa_proje','📋 *Teklif İstenecek (Proje):*'));pj.forEach(function(i){L.push(' '+i.q+'× '+i.n)});L.push('')}
return L.join('\n').replace(/\n{3,}/g,'\n\n').trim();
}
var QF=document.getElementById('fav-quote-form');
function submitQuote(e){
var f=e.target;
if(!QF||f!==QF)return;
e.preventDefault();e.stopPropagation();
if(!f.querySelector('[name="contact[email]"]')){location.href=location.pathname;return}
if(f.dataset.sending==='1')return;
if(f.reportValidity&&!f.reportValidity()){tst(T('toast_need_contact','Lütfen ad ve telefon girin.'),1);return}
if(!S.gn||!S.gn.length){try{rsm()}catch(er){}}
var sm=summary();
var hk=f.querySelector('[data-fq="konfig"]');if(hk)hk.value=sm;
var bd=f.querySelector('[name="contact[body]"]');
if(bd){if(bd.dataset.userNote==null)bd.dataset.userNote=bd.value||'';var un=bd.dataset.userNote.trim();bd.value=(un?un+'\n\n──────────\n':'')+sm;}
if(window.favQuoteStoreWA)window.favQuoteStoreWA();
f.dataset.sending='1';
var bw=Q('#bw');if(bw){bw.disabled=true;bw.style.opacity='.6'}
setTimeout(function(){f.dataset.sending='';if(bw){bw.disabled=false;bw.style.opacity=''}},10000);
var go2=function(){HTMLFormElement.prototype.submit.call(f)};
if(window.Shopify&&Shopify.captcha&&typeof Shopify.captcha.protect==='function'){Shopify.captcha.protect(f,go2)}else{go2()}
}
document.addEventListener('submit',submitQuote,true);
/* Gönderim sonrası (contact_posted / hata) sonuç kutusunu sayfanın üstüne taşı */
(function(){
if(!QF)return;
var rs2=QF.querySelector('[data-fq-result]'),host=document.getElementById('fav-cfg-quote-result');
if(rs2&&host&&rs2.querySelector('[data-fav-quote-open]')){host.appendChild(rs2);host.style.margin='0 0 16px';if(host.scrollIntoView)host.scrollIntoView({block:'start',behavior:'smooth'})}
})();

A('.sc').forEach(function(c){c.addEventListener('click',function(){
if(c.dataset.fv) return;
var fl=c.dataset.field,vu=c.dataset.value,mu=c.dataset.multi==='1';
if(mu){var ar=S.d[fl==='solutions'?'sols':fl],i=ar.indexOf(vu);if(i>=0) ar.splice(i,1); else ar.push(vu);c.classList.toggle('sel');}
else {A('.sc[data-field="'+fl+'"]').forEach(function(x){x.classList.remove('sel')});c.classList.add('sel');S.d[fl==='location'?'loc':fl]=vu;}
vl();
})});
['name','tel','co','nt'].forEach(function(k){var id={name:'#cn',tel:'#ct',co:'#cc',nt:'#cnt'}[k];var f=Q(id);if(f) f.addEventListener('input',function(e){S.d[k]=e.target.value})});
Q('#bn').addEventListener('click',function(){if(Q('#bn').disabled)return;if(S.s===S.T)return;S.s++;go(S.s)});
Q('#bb').addEventListener('click',function(){if(S.s===1)return;S.s--;go(S.s)});
A('.tb').forEach(function(tb){tb.addEventListener('click',function(){var t=+tb.dataset.tab;if(t<S.s){S.s=t;go(t)}})});
Q('#tgProj').addEventListener('change',function(e){S.showProj=e.target.checked;renderPlist()});
document.addEventListener('click',function(e){
var t=e.target.closest('[data-add]');if(!t)return;
var v=t.dataset.add,q=t.dataset.qty;t.disabled=true;t.textContent='...';
add(v,q).then(function(){t.className='ba ok';t.textContent=T('btn_item_added','✓ Eklendi');tst(T('toast_item_added','Sepete eklendi.'))}).catch(function(er){t.disabled=false;t.textContent=T('btn_add','+ Sepete Ekle');tst(T('toast_item_failed','Eklenemedi: ')+er.message,1)});
});
Q('#bca').addEventListener('click',addAll);
go(1);

})();
